import { useGetTotalNewIdeasDateRangeQuery } from '../../../../../apis/statistics/statistics-api.api.ts'
import { EChartsOption } from 'echarts'
import { DashboardChartBox } from '../dashboard-chart-box.tsx'
import ReactECharts from 'echarts-for-react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../redux/hooks.ts'
import { selectDashboardInput } from '../../../../../redux/slices/dashboard-input.slice.ts'
import dayjs from 'dayjs'
import echartsTheme from '../../../../../styles/echarts/echarts-theme.json'
import { selectThemeStyle } from '../../../../../features/setting/setting.slice.ts'

interface TotalNewIDeasChartProps {
  bookId: string
}

export const TotalNewIdeasChart: React.FC<TotalNewIDeasChartProps> = ({
  bookId,
}) => {
  const { t } = useTranslation()
  const dashboardInput = useAppSelector(selectDashboardInput)
  const themeStyle = useAppSelector(selectThemeStyle)
  const { data } = useGetTotalNewIdeasDateRangeQuery({
    bookId: bookId,
    startDate: dayjs(dashboardInput.dateRange[0]).format('YYYY-MM-DD'),
    endDate: dayjs(dashboardInput.dateRange[1]).format('YYYY-MM-DD'),
  })

  if (!data) return <></>

  const totalIdeas = data.data.long + data.data.short

  const chartOption: EChartsOption = {
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: 'center',
      bottom: 'bottom',
      textStyle: {
        color: themeStyle.sumText,
      },
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['60%', '70%'],
        data: [
          {
            value: data.data.long,
            name: 'Long',
          },
          {
            value: data.data.short,
            name: 'Short',
          },
        ],
        label: {
          show: false,
        },
      },
    ],
    graphic: {
      type: 'text',
      left: 'center',
      top: 'center',
      style: {
        text: `${totalIdeas} (${data.data.long} long/\n${data.data.short} short)`,
        fill: themeStyle.sumText,
        fontSize: 16,
      },
    },
  }

  return (
    <DashboardChartBox title={t('dashboard.total_new_ideas')}>
      <ReactECharts option={chartOption} theme={echartsTheme.themeName} />
    </DashboardChartBox>
  )
}
